import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { HomePage } from './pages/HomePage'
import { TomJerryMagicRing } from './pages/TomJerryMagicRing'
import { SmurfsMagicFlute } from './pages/SmurfsMagicFlute'
import { MorphleCartoon } from './pages/MorphleCartoon'
import { SearchResults } from './pages/SearchResults'
import { CategoryKids } from './pages/CategoryKids'
import { CategoryClassics } from './pages/CategoryClassics'
import { CategoryModern } from './pages/CategoryModern'
import { UserDashboard } from './pages/UserDashboard'

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/review/tom-jerry-magic-ring" element={<TomJerryMagicRing />} />
          <Route path="/review/smurfs-magic-flute" element={<SmurfsMagicFlute />} />
          <Route path="/review/morphle-cartoon" element={<MorphleCartoon />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/category/kids" element={<CategoryKids />} />
          <Route path="/category/classics" element={<CategoryClassics />} />
          <Route path="/category/modern" element={<CategoryModern />} />
          <Route path="/dashboard" element={<UserDashboard />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
